import { Controller } from "@hotwired/stimulus"
import { Chart, CategoryScale, Tooltip } from "chart.js"
import { MatrixController, MatrixElement } from "chartjs-chart-matrix"

// El plugin matrix se importa solo en este controller (no global) para no
// sumar peso al bundle de las paginas que no usan el heatmap.
Chart.register(MatrixController, MatrixElement, CategoryScale, Tooltip)

// Mapa de calor — matriz 7 dias x 24 horas de % de asistencia.
// Migra AttendanceHeatMap.tsx (react-apexcharts heatmap). Color base #008FFB.
export default class extends Controller {
  static values = {
    days: Array,
    hours: Array,
    matrix: Array,
  }

  connect() {
    const days = this.daysValue
    const hours = this.hoursValue
    const matrix = this.matrixValue

    let max = 0
    const points = []
    days.forEach((day, y) => {
      hours.forEach((hour, x) => {
        const value = (matrix[y] && matrix[y][x]) || 0
        if (value > max) max = value
        points.push({ x: hour, y: day, v: value })
      })
    })

    this.chart = new Chart(this.element.getContext("2d"), {
      type: "matrix",
      data: {
        datasets: [
          {
            data: points,
            backgroundColor: (ctx) => {
              const value = ctx.raw.v
              const alpha = max > 0 ? value / max : 0
              return `rgba(0, 143, 251, ${(0.08 + alpha * 0.92).toFixed(3)})`
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            width: ({ chart }) => ((chart.chartArea || {}).width || 0) / hours.length - 1,
            height: ({ chart }) => ((chart.chartArea || {}).height || 0) / days.length - 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "category",
            labels: hours,
            grid: { display: false },
            ticks: { color: "#7a7a7a", font: { size: 11 } },
            border: { display: false },
          },
          y: {
            type: "category",
            labels: days,
            offset: true,
            grid: { display: false },
            ticks: { color: "#7a7a7a", font: { size: 11 } },
            border: { display: false },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => `${items[0].raw.y} · ${items[0].raw.x}`,
              label: (item) => `${item.raw.v}%`,
            },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
